import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized-page',
    imports: [],
    templateUrl: './unauthorized-page.component.html',
    styleUrl: './unauthorized-page.component.scss'
})
export class UnauthorizedPageComponent {

}
